<template>
	<div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><a href="/">管理员管理</a></el-breadcrumb-item>
			<el-breadcrumb-item>管理员列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card>
			<el-row :gutter="20">
				<el-col :span="4">
					<el-button type="primary" @click="addDialog = true">添加管理员</el-button>
				</el-col>
			</el-row>

			<el-table :data="userList" border stripe>
				<el-table-column type="index" label="#"></el-table-column>
				<el-table-column prop="username" label="管理员名"></el-table-column>
				<el-table-column prop="password" label="密码"></el-table-column>
				<!-- <el-table-column prop="password" label="状态">
					<el-switch v-model="value" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-table-column> -->
				<!-- <el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<div v-if="scope.row.status==0" class="show1">待付款</div>
						<div v-if="scope.row.status==1" class="show2">待发货</div>
					</template>
				</el-table-column> -->

				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini"
							@click="showDialog(scope.row.id)"></el-button>
						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>
						<!-- <el-button type="warning" icon="el-icon-setting" size="mini"></el-button> -->
					</template>
				</el-table-column>

			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[2, 4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>

		<!-- 添加管理员得对话框 -->
		<el-dialog title="添加管理员" :visible.sync="addDialog" width="40%" @close="addDialogClosed">
			<span>
				<el-form ref="addFormRef" :model="addForm" label-width="70px">
					<el-form-item label="管理员名">
						<el-input v-model="addForm.username"></el-input>
					</el-form-item>
					<el-form-item label="密码">
						<el-input v-model="addForm.password"></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialog = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 修改管理员得对话框 -->
		<el-dialog title="修改管理员" :visible.sync="editDialog" width="40%">
			<span>
				<el-form ref="editFormRef" :model="editForm" label-width="70px">
					<el-form-item label="管理员名">
						<el-input v-model="editForm.username"></el-input>
					</el-form-item>
					<el-form-item label="密码">
						<el-input v-model="editForm.password"></el-input>
					</el-form-item>
				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="editDialog = false">取 消</el-button>
				<el-button type="primary" @click="editUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getUserList,
		addUserList,
		selectUserList,
		editUserList,
		delUserList
	} from '@/api/index.js'
	export default {
		data() {
			return {
				userList: [],
				selectUserObj: {},
				pageNum: 1,
				pageSize: 6,
				addForm: {
					username: "",
					password: "",
				},
				editForm: {},
				addDialog: false,
				editDialog: false,
				total: 0,
				value: true
			}
		},
		created() {
			this.getUsersList();
		},
		methods: {
			async getUsersList() {
				const {
					data: res
				} = await getUserList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				console.log(res);
				this.userList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			handleSizeChange(newsize) {
				this.pageSize = newsize;
				this.getUsersList();
			},
			handleCurrentChange(newnum) {
				this.pageNum = newnum;
				this.getUsersList();
			},
			addDialogClosed() {
				this.addForm.username = "";
				this.addForm.password = "";
			},
			async addUser() {
				const {
					data: res
				} = await addUserList({
					username: this.addForm.username,
					password: this.addForm.password
				});
				console.log(res);
				if (res.code == 200) {
					this.$message.success('添加成功');
					this.addDialog = false;
					this.getUsersList();
				} else {
					this.$message.error('添加失败');
				}
			},
			async showDialog(id) {
				const {
					data: res
				} = await selectUserList({
					id: id
				})
				console.log(res);
				// console.log(id);
				this.editDialog = true;
				this.editForm = res.data;
			},
			async editUser() {
				console.log(this.editForm.id);
				const {
					data: res
				} = await editUserList({
					password: this.editForm.password,
					username: this.editForm.username,
					id: this.editForm.id
				})

				this.editDialog = false;
				if (res.code == 200) {
					this.$message.success('修改成功')
				} else {
					this.$message.error('修改失败')
				}
				this.getUsersList();
			},
			async del(id) {
				const {
					data: res
				} = await delUserList({
					userid: id
				})
				console.log(res);
				if (res.code == 200) {
					this.$message.success('删除成功')
				} else {
					this.$message.error('删除失败')
				}
				this.getUsersList();
			}
		}
	}
</script>
<style scoped>
	.el-card {
		margin-top: 20px;
	}

	.el-row {
		margin-bottom: 20px;
	}
</style>